import { useState } from "react";
import CalendarGrid from "./components/CalendarGrid";
import EventModal from "./components/EventModal";
import "./index.css";

export default function App() {
  const [selectedDate, setSelectedDate] = useState(null);
  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const addEvent = (date, title) => {
    setEvents([...events, { date, title }]);
  };

  return (
    <div className="min-h-screen bg-white text-gray-900 p-4">
      <h1 className="text-3xl font-bold mb-6 text-center">The Good Planner</h1>
      <CalendarGrid
        events={events}
        onDateClick={(date) => {
          setSelectedDate(date);
          setShowModal(true);
        }}
      />
      {showModal && (
        <EventModal
          date={selectedDate}
          onClose={() => setShowModal(false)}
          onSave={addEvent}
        />
      )}
    </div>
  );
} 
// Triggering deploy